<div class="container">
  <orbit-fa-icon class="icon" [iconName]="icon()" />
  <span class="text">{{ infoText() }}</span>
</div>
